(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("_"), require("@wix/draft-js"), require("ReactDOM"), require("ReactDOMServer"));
	else if(typeof define === 'function' && define.amd)
		define("communitiesBlogRce", ["React", "_", "@wix/draft-js", "ReactDOM", "ReactDOMServer"], factory);
	else if(typeof exports === 'object')
		exports["communitiesBlogRce"] = factory(require("React"), require("_"), require("@wix/draft-js"), require("ReactDOM"), require("ReactDOMServer"));
	else
		root["communitiesBlogRce"] = factory(root["React"], root["_"], root["Draft"], root["ReactDOM"], root["ReactDOMServer"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__443__) {
return 